import { musteriSec, musteriSecenekleri, KademeSecimi, PoSatiri } from './poKademe';

/**
 * Mesai Talebi depo eşleşmesi (30.10.2026, #507; sunucudaki MesaiDepoEslesme ile aynı kural).
 * QR noktasına müşteri seçilmişse talepte yalnız o müşterilerin PO satırları; müşteriye bölüm seçilmişse yalnız o bölümler,
 * seçilmemişse müşterinin bütün bölümleri. Eşleşme yoksa bütün satırlar (bugünkü davranış).
 */

export interface DepoMusterisi { musteriId: string, bolumIdleri: string[] }
export interface DepoSecenegi { mesaiNoktasiId: string, ad: string, musteriler?: DepoMusterisi[] }

export const depoPoSatirlari = <T extends PoSatiri>(satirlar: T[], depo: DepoSecenegi | undefined): T[] => {
    const eslesme = depo?.musteriler ?? [];
    if (eslesme.length == 0)
        return satirlar;
    return satirlar.filter(x => {
        const m = eslesme.find(e => e.musteriId == x.customerId);
        return m != undefined && (m.bolumIdleri.length == 0 || (!!x.divisionId && m.bolumIdleri.includes(x.divisionId)));
    });
}

/** Depo seçilince: tek müşteri kalırsa seçilir; tek bölüm / PO / PO No kalırsa zincir kendiliğinden ilerler. */
export const depoVarsayilanKademe = (satirlar: PoSatiri[]): KademeSecimi => {
    const m = musteriSecenekleri(satirlar);
    return m.length == 1 ? musteriSec(satirlar, {}, m[0].value) : {};
}

/** Yeni talepte varsayılan depo: kullanıcı tek depoda yetkiliyse sunucunun verdiği, yoksa listede tek depo varsa o. */
export const varsayilanDepoId = (depolar: DepoSecenegi[], sunucuVarsayilani: string | null | undefined) =>
    sunucuVarsayilani && depolar.some(x => x.mesaiNoktasiId == sunucuVarsayilani)
        ? sunucuVarsayilani
        : depolar.length == 1 ? depolar[0].mesaiNoktasiId : undefined;
